export const COLOR = {
  GRAY: '#E6E6E6',
  PHOTO_BACKGROUND: '#E7E8FD',
  PHOTO_BORDER: '#CBCEFC',
  HEADER_BORDER: '#898AA8',
};
